<template>
  <div class="user-password-forgot">
    <h1>Glemt Passord?</h1>

    {{email}}

    <form @submit.prevent="handleSubmit">
      <div style="border: 1px solid red" v-if="errors.any()">
        Form has errors

        {{ errors }}
      </div>

      <div>
          <label>
            Din Epost adresse
            <input type="email" v-model="email" name="email" v-validate="'required|email'" :class="{ 'error': errors.any() }">
          </label>
          <div class="error" v-if="errors.any()">
            Kunne ikke be om tilbakestilling av passord
          </div>
      </div>

      <div>
        <button type="submit" class="success button" :disabled="!isSubmittable">Go</button>
        <br>
        Submittable: {{isSubmittable}}<br>
        Processing: {{processing}}
      </div>
    </form>
  </div>
</template>

<script>
import AuthService from '@/services/AuthService'

export default {
  name: 'UserPasswordForgot',
  data () {
    return {
      email: '',
      processing: false
    }
  },
  methods: {
    handleSubmit: function () {
      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            // Got errors - do no API request
            this.processing = false
          } else {
            // No errors, so try to save

            let data = { email: this.email }

            AuthService.forgotPassword(data)
              .then((response) => {
                this.$helpers.showSuccessAlert('En e-post med en tilbakestilt passord lenke er sendt til e-posten din')

                this.email = ''
              })
              .catch((error) => {
                // Put API errors into the error container
                this.$helpers.sendApiErrorsToValidator(error, this.errors, 'email')

                // Check if new errors appeared
                if (this.errors.any()) {
                  this.$validator.resume()
                } else {
                  this.$helpers.showErrorAlert('Noe gikk galt, prøv igjen', '', 2500)
                }
              })
              .then(() => {
                this.processing = false
              })
          }
        })
    }
  },
  computed: {
    isSubmittable: function () {
      return !(this.processing || this.errors.any())
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Guest/UserPasswordForgot.vue